(function ($, window, document) {



	//
	// ... code out here will run immediately on load
	//
	//
	const debounce = function (func, delay) {
		let timer;
		return function () {
			//anonymous function
			const context = this;
			const args = arguments;
			clearTimeout(timer);
			timer = setTimeout(() => {
				func.apply(context, args);
			}, delay);
		};
	};
	//
	const throttle = (func, limit) => {
		let inThrottle;
		return function () {
			const args = arguments;
			const context = this;
			if (!inThrottle) {
				func.apply(context, args);
				inThrottle = true;
				setTimeout(() => (inThrottle = false), limit);
			}
		};
	};
	$(function () {
		const headerNav = {
			//
			headerElem: $("header.header"),
			//
			_instance: function () {},
			//
			_navIconHandler: function () {},
			_resizeHandler: function () {},
			_scrollHandler: function () {},
			//_closeAllMenus: function () {},
		};

		//
		// * Clear the search form for WP-style search (on search results page)
		$(".nu__sitesearch-close").click(function () {
			$(".search-results-info").find(".search-field").val("");
			$(".navlinks--container").find(".search-field").val("");
		});

		//
		// ... code in here will run after jQuery says document is ready
		//
		const main_nav = {
			searchToggle: undefined,
			navicons: undefined,
			//navlinks: undefined,
			//submenuToggles: undefined,
			//parentMenuItems: undefined,

			//
			_init: function () {
				//
				// hoist variables
				//
				main_nav.searchToggle = $(".sitesearch-container");
				main_nav.navicons = $("header.header > .container > .navicons");
				// main_nav.navlinks = $(
				// 	"header.header > .container > .navlinks--container > .navlinks"
				// );
				// main_nav.submenuToggles = $(main_nav.navlinks).find(
				// 	".menu-item-has-children > button.navlinks-showsubmenu"
				// );
				// main_nav.parentMenuItems = $(main_nav.navlinks).find(
				// 	".menu-item-has-children"
				// );
				//
				// attach event handlers
				//
				// $(document).on("click", function (event) {
				// 	if (
				// 		$(event.target).closest("header.header, body.search, .takeover-nav")
				// 			.length === 0
				// 	) {
				// 		main_nav._reset_all_revealed_elems();
				// 	}
				// });

				// if ($("header.header .navlinks").length != 0) {
				// 	$(window).on("resize scroll", main_nav._reset_all_revealed_elems);
				// }

				main_nav.searchToggle.on(
					"click",
					".sitesearch-toggle",
					main_nav._did_click_searchform_toggle
				);

				//main_nav.submenuToggles.on("click", main_nav._did_click_submenu_toggle);

				main_nav.navicons.on("click", main_nav._did_click_navicons);
			},
			//
			//
			//
			_reset_all_revealed_elems: function () {
				if ($(".sitesearch-container .search-form").length) {
					let site_search_form = $(
						".sitesearch-container .search-form .search-field"
					);
					site_search_form.val("");
				}

				//main_nav.parentMenuItems.removeClass("revealed");

				// ? this is a bit hacky...
				// ? - the real problem is that on mobile; when you click the search input it "scrolls" the page and closes everything!
				// if (window.innerWidth >= 1250) {
				// 	main_nav.navlinks
				// 		.parent(".navlinks--container")
				// 		.removeClass("revealed");

				// 	main_nav.searchToggle.removeClass("revealed");
				// 	main_nav.navicons.removeClass("revealed");
				// 	$("body").removeClass("has-revealed-mobile-navmenu");
				// }
			},
			//
			//
			//
			_did_click_searchform_toggle: function (e) {
				$(e.delegateTarget).toggleClass("revealed");
			},
			//
			//
			//
			// _did_click_submenu_toggle: function (e) {

			// 	// traverse up to the <li.menu-item-has-children>
			// 	let the_toggled_menu_item = $(e.target.offsetParent);

			// 	// traverse up to the top level of this stack in the menu
			// 	let the_top_level_parent_item = $(e.target).closest(
			// 		".navlinks > .menu > .menu-item"
			// 	);

			// 	// hide any open menus that are not in this items lineage
			// 	$(the_top_level_parent_item).siblings().removeClass("revealed");
			// 	$(the_top_level_parent_item)
			// 		.siblings()
			// 		.find(".revealed")
			// 		.removeClass("revealed");
			// 	// hide any open menus that are in this items lineage, except the furthest ancestor
			// 	$(the_toggled_menu_item).siblings().removeClass("revealed");

			// 	// reveal this item's submenu
			// 	the_toggled_menu_item.toggleClass("revealed"); // toggle this <li> reveal class (active state)
			// },
			//
			//
			//
			_did_click_navicons: function (e) {
				$("body").toggleClass("has-revealed-mobile-navmenu");
				$(this).toggleClass("revealed");
				$(this).next(".navlinks--container").toggleClass("revealed");
			},
			//
			//
			//
		};
		//
		//
		//
		main_nav._init();








		function closeSubmenus() {
			$('.navlinks .menu .menu-item-has-children > .sub-menu').slideUp();
		}


		$('.navlinks .menu .menu-item-has-children > a').click(function(e) {
			e.preventDefault(); // Prevent default action of the link
			var $submenu = $(this).siblings('.sub-menu');
        // Close all other open submenus
        $('.navlinks .menu .menu-item-has-children > a').not(this).siblings('.sub-menu').slideUp();
        // Toggle visibility of the clicked submenu
        $submenu.slideToggle();
		});





		$(document).on('click', function(event) {
			// Check if the click target is not a descendant of .main-menu
			if (!$(event.target).closest('.navlinks .menu').length) {
					// Close all submenus
					closeSubmenus();
			}
		});





		$(window).scroll(function(){
			if ($(this).scrollTop() > 120) {
				// Close all submenus
        closeSubmenus();
				 $("svg.mv-logo").removeClass("large").addClass("small");
				 $("header.header > .container").removeClass("large").addClass("small");
			} else {
				 $("svg.mv-logo").removeClass("small").addClass("large");
				 $("header.header > .container").removeClass("small").addClass("large");

			}
		});





		// let searchTerm = new URLSearchParams(window.location.search).get("s");
		// if (searchTerm) {
		// 		sessionStorage.setItem("searchTerm", searchTerm); // Store the term

		// }
		//turn on below for search term stuff.
		// const params = new URLSearchParams(window.location.search);
    // const term = params.get("s"); // Get the search term


		// if (term) {
		// 		sessionStorage.setItem("searchTerm", term); // Store it for later use
		// }



		//
		// ? end of $.ready
		//
	});
})(window.jQuery, window, document);
